<template>
  <div style="height: 100%;">
    <loading-panel v-if="this.loading"></loading-panel>
    <div v-else class="auth-layout-container bg-default">
      <div class="main-content login-app">
        <div class="auth-super-container container">
          <div class="row justify-content-center">
            <div class="xs-size">
              <div class="auth-container">
                <div class="auth-container__logo">
                  <router-link :to="'/'">
                    <img
                      :src="
                      require(`@/assets/images/logo/logo.png`)
                    "
                      alt="Maquillate logo"
                    />
                  </router-link>
                </div>

                <div class="bg-white mt-4 rounded mb-0 auth-container__form">
                  <div class="card-body pb-0">
                    <div class="text-center text-muted mb-0">
                      <div class="auth-container__form__title text-default">
                        <h2 class="text-default">REVISA TU BANDEJA DE ENTRADA</h2>
                      </div>
                      <div class="auth-container__form__description text-default">
                        <h3 class="text-default">
                          Para continuar, ingresa el código que acabamos de enviarte a {{ this.email }}
                        </h3>
                      </div>
                    </div>
                    <validation-observer
                      ref="formValidator"
                      v-slot="{ handleSubmit }"
                    >
                      <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                        <div style="display: flex; flex-direction: row;">
                          <v-otp-input
                            ref="otpInput"
                            style="width:100%;justify-content: space-between;"
                            input-classes="otp-input"
                            separator=""
                            :num-inputs="6"
                            :should-auto-focus="true"
                            :is-input-num="true"
                            @on-complete="handleOnComplete"
                          />
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div class="text-center">
                              <base-button
                                block
                                :disabled="!data.otp"
                                :loading="buttonLoading"
                                class="mt-4"
                                native-type="submit"
                                type="dark"
                              >Continuar
                              </base-button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </validation-observer>
                  </div>
                </div>

                <div>
                  <div class="col-12 text-center text-white mt-3">
                    <div class="auth-link" @click="resendCode" style="cursor: pointer;">
                      <small class="text-default">¿No has recibido el código? Reenviar</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AUTH_CHECK_CODE, AUTH_CODE, AUTH_MAGIC_LINK } from '@/store/actions/login';
import { mapGetters } from 'vuex';
import BaseButton from '../../components/BaseButton';
import OtpInput from '@bachdgvn/vue-otp-input';
import LoadingPanel from '../../components/LoadingPanel';

export default {
  name: 'UserVerificationLogin',
  components: {
    BaseButton,
    LoadingPanel,
    VOtpInput: OtpInput,
  },
  data () {
    return {
      data: {
        otp: '',
      },
      email: '',
      originalEmail: '',
      code: '',
      loading: true,
      buttonLoading: false,
      error: false,
    };
  },
  computed: {
    ...mapGetters(['getProfile']),
  },
  watch: {},
  metaInfo () {
    return {
      title: 'Inicia sesión - Maquillate.com',
    };
  },
  mounted () {
    this.getInfoCode();
  },
  methods: {
    handleOnChange (value) {
      console.log('OTP changed: ', value);
    },
    handleOnComplete (value) {
      console.log(value);
      this.data.otp = value;
    },
    onSubmit () {
      const otp = this.data.otp;
      if (otp.length !== 6) {
        return this.notify(
          'El código es incorrecto',
          'danger',
        );
      }

      this.buttonLoading = true;

      this.$store
        .dispatch(AUTH_CHECK_CODE, { otp, invitation_code: this.$route.query.invitation_code })
        .then((data) => {

          if (!data.success) {
            return this.notify(
              'El código es incorrecto ha expirado',
              'danger',
            );
          }

          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.has('redirect_url')) {
            window.location = urlParams.get('redirect_url');
          } else {
            window.location = window.location.origin;
          }

        }).catch((error) => {
        return this.notify(
          error,
          'danger',
        );
      })
        .finally(() => (this.buttonLoading = false));

    },
    resendCode () {
      let data = {
        email: this.originalEmail,
      };
      this.$store
        .dispatch(AUTH_MAGIC_LINK, data)
        .then((data) => {

          if (data.code) {
            this.notify(
              'El código se ha enviado a correo electrónico ',
              'success',
            );

            window.location.href = `/verify-user/${data.code}${this.$route.query.invitation_code ? `?invitation_code=${this.$route.query.invitation_code}` : ''}`;
          }
        })
        .catch(() => {
          this.error = true;
        });
    },
    getInfoCode () {
      console.log(this.$router);
      this.$store
        .dispatch(AUTH_CODE, this.$route.params.code)
        .then((data) => {
          const [alias, domain] = data.email.replaceAll(/(?<=.).(?=.*@)/g, '*')?.split('@');
          const [prefix, abv] = domain?.split('.');
          const maskedPrefix = prefix.replaceAll(/(?<=.)./g, '*');
          this.email = `${alias}@${maskedPrefix}.${abv}`;
          this.originalEmail = data.email;
        })
        .finally(() => (this.loading = false));
    },
    notify (message, type) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
  },
};
</script>

<style scoped>


.auth-layout-container .md-field .md-input,
.auth-layout-container .md-field .md-textarea,
.auth-layout-container .select-country {
  box-shadow: none !important;
}

.auth-layout-container .md-field .md-input,
.auth-layout-container .md-field .md-textarea,
.auth-layout-container .border-color {
  border: 1px solid #d4d4d4 !important;
}

.md-field .md-input,
.md-field .md-input:focus,
.md-field .md-textarea,
.md-field .md-textarea:focus,
.border-color {
  border: 1px solid #d4d4d4 !important;
}

</style>
